
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kebijakan-privasi",
      function () {
        return require("private-next-pages/kebijakan-privasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kebijakan-privasi"])
      });
    }
  